module.exports = __webpack_public_path__ + "static/media/tada.f7d3e299.png";